import { render, staticRenderFns } from "./MeusPontos.vue?vue&type=template&id=15007f43"
import script from "./MeusPontos.vue?vue&type=script&lang=js"
export * from "./MeusPontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports